import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { onAuthStateChanged }  from "firebase/auth";
import { auth, fetchUserProfile } from "../../firebase";
import { setUser, clearUser, setLoading } from "../store/usersSlice";

const AuthListener = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(true));

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          let userProfile;
          while (!userProfile) {
            userProfile = await fetchUserProfile(user.uid);
          }

          dispatch(
            setUser({
              id: user.uid,
              email: user.email,
              name: userProfile.name,
              listsId: userProfile.listsId,
              collabId: userProfile.collabId
            })
          );
        } catch (error) {
          console.error("Error fetching user profile: ", error);
        }
      } else {
        dispatch(clearUser());
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return children;
};

export default AuthListener;